import { useTranslation } from "react-i18next";
import type { HumanStepRequestedPayload, ThreadEntry } from "../../../api/threads/liveMessages";
import { answerHumanStep, newClientKey } from "../../../api/threads/threadsApi";
import { FORM_HELP_TEXT_CLASS } from "../../../ui/styles/formStyles";
import { inputText } from "../../threads/entries/humanStepResponse";
import KeepMemoryForm from "../keep/KeepMemoryForm";
import { PASSAGES_INPUT, readPassagesInput } from "../keep/passageInput";
import { notifyMemoriesChanged } from "../memoryEvents";

interface KeepMemoryStepProps {
  readonly threadId: string;
  readonly projectId: string;
  readonly entry: ThreadEntry;
  readonly payload: HumanStepRequestedPayload;
}

/**
 * "Keep a memory"'s step (ADR-0031 D5): the keep form over the passages the step's input
 * names. Keeping answers the step; the memories service keeps the memory in this Thread, the
 * keeper's own and active at once, which ends the Workflow.
 */
export default function KeepMemoryStep({ threadId, entry, payload }: KeepMemoryStepProps) {
  const { t } = useTranslation();
  const text = inputText(payload, PASSAGES_INPUT);
  const sources = text === null ? null : readPassagesInput(text);
  if (sources === null) return <p className={FORM_HELP_TEXT_CLASS}>{t("memories.step.noPassages")}</p>;
  return (
    <KeepMemoryForm
      sources={sources}
      onKeep={async (memory) => {
        await answerHumanStep(threadId, { answersEntry: entry.number, comment: null, choice: null, result: null, memory: { ...memory, sources: [...memory.sources] }, clientRequestId: newClientKey() });
        notifyMemoriesChanged();
      }}
    />
  );
}
